import Products from 'Vue/containers/Products.vue';
// @ts-ignore
import { createApp } from "vue";
import store from "Store/index";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.addVueApp = function () {
	const products = createApp(Products).use(store);
	products.mount("#products-grid");
};


module.init = function () {
	module.addVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
